/* eslint-disable no-unused-vars */

import { useContext, useEffect } from "react";
import { AnimationMixer, LoopOnce } from "three";
import { SettingsContext } from "../context";

function AnimationList({
  animationSpeed,
  animationType,
  setSelectedAnimationName,
}) {
  const hotspotType = "1";
  const { setAnimations, animations } = useContext(SettingsContext);

  useEffect(() => {
    const modelViewer = document.getElementById("modelViewer");
    modelViewer.addEventListener("init-model-load", loadAnimations.bind(this));
    document.addEventListener("glb-loaded", loadAnimations.bind(this));

    loadAnimations();
  }, []);

  const loadAnimations = async () => {
    const modelViewer = document.getElementById("modelViewer");
    document.removeEventListener("glb-loaded", loadAnimations);
    const scene = modelViewer?.scene();
    if (!scene.animations || scene.animations.length == 0) {
      console.warn("animations not found!!!");
      return;
    }

    let newAnimations = [];
    let animationActions = [];
    let animationMixer = new AnimationMixer(scene);

    scene.animations.forEach((clip) => {
      let animInfo = {
        id: clip.uuid,
        name: clip.name,
        duration: clip.duration,
        selected: false,
      };
      newAnimations.push(animInfo);

      const action = animationMixer.clipAction(clip);
      action.clampWhenFinished = true;
      action.loop = LoopOnce;
      action.reset();
      action.time = 0.1;
      animationActions.push(action);
    });

    setAnimations(newAnimations);
  };

  const playAnimation = (index) => {
    const modelViewer = document.getElementById("modelViewer");
    const animationController =
      modelViewer.hotspotConroller.hotsportControllers.filter(
        (b) => b.type == hotspotType
      )[0];

    if (!animationController) return;

    let anim = animations[index];
    animationController.playAnimation(anim.name, animationType, animationSpeed);
  };

  const handleAnimationSelection = (e, index) => {
    animations[index].selected = e.target.checked;
    updateSelectedAnimationName();
  };

  const updateSelectedAnimationName = () => {
    let names = [];
    animations.forEach((element) => {
      if (!element.selected) return;

      names.push([element.name]);
    });

    let name = names.join(";");
    setSelectedAnimationName(name);
    return name;
  };

  return (
    <>
      {animations?.map((animation, index) => {
        return (
          <div
            key={index}
            className="anim_widget"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div className="widget_player">
              <div className="children">
                <div className="anim_widget_wrapper">
                  {/*
                      <div className="visibility selected" >
                      <i className="eye icon" />
                    </div>
                    <div className="visibility">
                      <i className="eye slash icon" />
                    </div> */}

                  <div>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        handleAnimationSelection(e, index);
                      }}
                    />
                  </div>

                  <div
                    className="playIcon"
                    onClick={(e) => {
                      playAnimation(index);
                    }}
                  >
                    <i className="play circle icon" />
                  </div>
                  <div className="name">
                    <p>{animation.name}</p>
                  </div>
                  <div className="duration">
                    <p>{animation?.duration.toString().substr(0, 4)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default AnimationList;
